import { render, staticRenderFns } from "./CorpGreeting.vue?vue&type=template&id=6fe903a6&scoped=true&"
import script from "./CorpGreeting.vue?vue&type=script&lang=ts&"
export * from "./CorpGreeting.vue?vue&type=script&lang=ts&"
import style0 from "./CorpGreeting.vue?vue&type=style&index=0&id=6fe903a6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe903a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
